import { render } from "./SiteLinkItem.vue?vue&type=template&id=cbccd7aa"
import script from "./SiteLinkItem.vue?vue&type=script&lang=js"
export * from "./SiteLinkItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/SiteLinkItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cbccd7aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cbccd7aa', __exports__)) {
    api.reload('cbccd7aa', __exports__)
  }
  
  module.hot.accept("./SiteLinkItem.vue?vue&type=template&id=cbccd7aa", () => {
    api.rerender('cbccd7aa', render)
  })

}


export default __exports__